<template>
<div class="select-item animate__animated animate__fadeInUp animate__slower" v-if="SelectItem">
  <div class="item-img" >
    <img :src="'http://'+ SelectItem.photoInfoVO.address" >
  </div>
  <div class="note-text">
    <pre>{{SelectItem.photoInfoVO.description}}</pre>
    <ripeav-more ripeav-more="查看更多" url-link="/qualification"></ripeav-more>
  </div>
</div>
</template>

<script>
import RipeavMore from "../../components/RipeavMore";
export default {
  name: "HomeSelectItem",
  components: {RipeavMore},
  props:{
    SelectItem:{

    }
  },
  created() {
      // console.log(this.SelectItem);
  },
  methods:{
    HandleGoQua(){
      this.$router.push('/home/qualification')
    }
  }
}
</script>

<style lang="less" scoped>
.select-item{
  min-height: 42.1vh;
  display: flex;

  .item-img{
    width: 600px;
    height: 400px;
    overflow: hidden;

    img{
      width: 100%;
      height: 100%;
      transition: all 0.6s ease;
      &:hover{
        cursor: pointer;
        transform: scale(1.1);
      }
    }
  }
  .note-text{
    margin-left: 100px;
    width: 33.0vw;
    min-height: 130px;
    padding-top: 40px;
    padding-left: 40px;
    pre{
      cursor: default;
      white-space: pre-wrap;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      margin-bottom: 70px;
      text-align: left;
    }
  }
}
</style>